<template lang="pug">

    v-card.creat-video-list-item.d-flex.flex-column(
      v-if="video",
      flat
      height="100px"
      :width="this.$vuetify.breakpoint.xs ? '90%' : itemsCount < 4 ? 240 : itemsCount < 8 ? 180 : 100"
      @click="chooseAsActive"
     
    )
      v-tooltip(top color="primary")
        template(v-slot:activator="{ on, attrs }")
          v-img.white--text( v-bind="attrs" v-on="on"  height="100px" :src="displayThumbnail(video)")
            v-row.play-overlay.fill-height.ma-0()
              .videoTitle(v-if="video.length") {{fmtMSS(video.length, true)}}
              .d-flex.flex-row.justify-space-between.w-full.flex-grow-1.pa-2
                v-icon.d-block.white--text(x-small v-if="video.overlays && video.overlays.length > 0") fa fa-layer-group
                v-icon(v-else)
                v-menu.py-0(top='' dense v-model="moreMenu" content-class="elevation-25" offset-y offset-x :close-on-click='true')
                  template(v-slot:activator='{ on, attrs }')
                    v-btn.menuBtn(color='primary' x-small dark='' text v-bind='attrs' v-on='on')
                      v-icon.white--text(small) fa fa-ellipsis-h
                  v-list.py-0(dense)
                    EditOverlaysDialog.vue(:clip="video" @clicked="moreMenu = false" @submit="submitLayerDialog")
                    v-divider
                    v-list-item(@click="removeElementFromTimeline(video)")
                      v-list-item-icon.mr-2
                        v-icon(small) delete
                      v-list-item-title {{$t('create.remove')}}
        span {{video.title}}

</template>
<script>
import urlFormat from "@/utils/urlFormat";
import { fmtMSS } from "@/utils/format";
import { mapMutations } from "vuex";
import EditOverlaysDialog from "@/components/create/EditOverlaysDialog.vue";
export default {
  name: "TimelineClipItem",
  components: {
    EditOverlaysDialog,
  },
  props: ["video", "index", "itemsCount"],
  data() {
    return {
      fab: false,
      moreMenu: false,
    };
  },
  methods: {
    ...urlFormat,
    fmtMSS,
    submitLayerDialog(layerData) {
      this.$parent.$emit("layerChanged", layerData);
    },
    chooseAsActive() {
      this.$parent.$emit("clicked", this.video);
    },
    isMobile() {
      return this.$vuetify.breakpoint.xs;
    },
    ...mapMutations("create", {
      removeElementFromTimeline: "remove_element_from_timeline",
    }),
    displayThumbnail(item) {
      const src = this.getThumbnailUrl(item.id, item.token, item.element);
      return src;
    },
  },
};
</script>
<style lang="sass" scoped>
@import '@/assets/style/variables'


.creat-video-list-item
  border-radius: 12px
  width: 100%
  overflow: hidden
  background-color: $primary

  @media only screen and (max-width: 600px)
    margin: 10px auto !important

  .play-overlay
    background: rgba(0,0,0,0.2)
    cursor: pointer
    position: relative
    transition: $transition
    opacity: 0
    border-radius: 12px
    border: 2px solid transparent
    .videoTitle
      position: absolute
      color: white
      font-size: 0.8rem
      background-color: rgba(0,0,0,0.4)
      border-radius: 12px
      padding: 0px 6px
      bottom: 10px
      left: 12px
      max-width: 85%
      white-space: nowrap
      overflow: hidden
      text-overflow: ellipsis
      font-weight: 600
    .menuBtn

      height: 12px
      min-width: 20px
      padding: 4px
      &:hover
        background-color: $accent
  .absolute
    position: absolute
    top: 8px
    right: 10px
    align-content: center
    margin: 0
    padding: 0
    &:hover
      background: $accent
  &.active
    .play-overlay
      border: 2px solid $accent
      opacity: 1
  &:hover
    .play-overlay
      opacity: 1
    // .addVideoArea
    //   background: rgba(255,255,255, 0.1)
    //   transition: all .35s ease-in-out
    //   .v-icon
    //     opacity: 0.6
    //     transition: all .35s ease-in-out
    //   &:hover
    //     background: rgba(255,255,255, 0.6)
    //     .v-icon
    //       opacity: 1
</style>
